import {
  type EditionCategoryDetailResponse,
  getEditionCategories,
} from '@api/edition-categories-api';

export type { EditionCategoryDetailResponse };

/** Fetches all categories assigned to an edition with details. */
export function getCategoriesByEdition(
  editionId: string,
): Promise<EditionCategoryDetailResponse[]> {
  return getEditionCategories(editionId);
}
